import * as React from 'react';
import './LogoutComponent.css';

import {t} from 'react-multi-lang';
import {ILogoutProps} from "../../containers/LogoutContainer";

class LogoutComponent extends React.PureComponent<ILogoutProps> {
    constructor(props: ILogoutProps) {
        super(props);

        this.logout = this.logout.bind(this);
    }

    public render() {
        return (
            <>
                <div className="w_header">{t('logout.logout')}</div>
                <div className="w_component w_component_fill text-center">
                    <h6>{t('logout.instructions')}</h6>
                    <button className={"btn btn-secondary btn-lg btn-danger ml-2 mr-2"} onClick={this.logout}
                            title={t('logout.hover')}>
                        {t('logout.logout')}
                    </button>
                </div>
            </>
        );
    }

    private logout() {
        this.props.dispatchDisconnectInstance();
        this.props.history.push('/');
    }
}

export default LogoutComponent;


// WEBPACK FOOTER //
// ./src/components/LogoutComponent/LogoutComponent.tsx